import { RuleDefinition } from 'controls/queryBuilder/ruleDefinition';
import { translator } from 'core/localization';
import { getListLazy } from 'components/Select/utils/getListLazy';

const i18n = translator({
	Columns: {},
	Path: {},
});

export type ApiRequestPayload = {
	[p: string]: unknown;
	filter: RuleDefinition;
	sort: { field: string; dir: 'asc' | 'desc' }[];
};

export enum GroupByMode {
	columns = 'columns',
	path = 'path',
}

export const getGroupByModeOptions = getListLazy(() => {
	return [
		{
			label: i18n('Group by columns'),
			value: GroupByMode.columns,
		},
		{
			label: i18n('Group by path'),
			value: GroupByMode.path,
		},
	];
});
